var red = document.querySelector('#flicker');

function setProperty(duration) {
  red.style.setProperty('--animation-time', duration +'ms');
}

function changeAnimationTime() {
  var animationDuration = (Math.random() * 500) + 100;
  setProperty(animationDuration);
}

setInterval(changeAnimationTime, 800);